import * as LabelPrimitive from '@radix-ui/react-label';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '../lib/cn';

export type LabelProps = ComponentPropsWithoutRef<typeof LabelPrimitive.Root>;

/**
 * Labels are data chrome, so they take JetBrains Mono: uppercase, tracked out,
 * small. Radix's Label stops the double-click-to-select behaviour that native
 * labels have when clicked repeatedly.
 */
export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { className, ...rest },
  ref,
) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'font-mono text-[0.7rem] font-medium uppercase leading-none tracking-[0.12em] text-muted',
        'select-none',
        className,
      )}
      {...rest}
    />
  );
});
